import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import { __, always, both, ifElse, path, propSatisfies } from 'ramda';
import { Row, Label, Value } from './summary.styles';
import BookingCard from '../../../../shared/components/bookingCard/bookingCard.container';
import messages from './messages';
import { renderWhenTrue } from '../../../../shared/utils/rendering';

export class Summary extends PureComponent {
  static propTypes = {
    discountPercent: PropTypes.number,
    discountValue: PropTypes.number,
    selectedTickets: PropTypes.object,
    ticketTypes: PropTypes.object,
    isGroupExperience: PropTypes.bool,
    groupPrice: PropTypes.number,
  };

  getTicketPrice = ticketType => path([ticketType, 'price'], this.props.ticketTypes);

  isTicketTypeSelected = propSatisfies((amount = 0) => amount > 0, __, this.props.selectedTickets);

  renderRow = ({ labelKey, amount, singleValue, totalValue }) => (
    <Row>
      <Label>
        <FormattedMessage {...messages[labelKey]} values={{ amount, value: singleValue }} />
      </Label>
      <Value>
        {totalValue < 0 ? '-' : ''}${Math.abs(totalValue)}
      </Value>
    </Row>
  );

  renderGroupRow = renderWhenTrue(() =>
    this.renderRow({
      labelKey: 'group',
      totalValue: this.props.groupPrice,
    })
  );

  renderTicketRow = ifElse(
    both(this.isTicketTypeSelected, always(!this.props.isGroupExperience)),
    ticketType => {
      const amount = this.props.selectedTickets[ticketType];
      const singlePrice = this.getTicketPrice(ticketType);

      return this.renderRow({
        labelKey: ticketType,
        amount,
        singleValue: singlePrice,
        totalValue: amount * singlePrice,
      });
    },
    always(null)
  );

  renderDiscountRow = renderWhenTrue(() =>
    this.renderRow({
      labelKey: 'discount',
      singleValue: this.props.discountPercent,
      totalValue: -this.props.discountValue,
    })
  );

  render = () => (
    <BookingCard noImage>
      {this.renderTicketRow('adult')}
      {this.renderTicketRow('child')}
      {this.renderTicketRow('infant')}
      {this.renderGroupRow(this.props.isGroupExperience)}
      {this.renderDiscountRow(this.props.discountValue > 0)}
    </BookingCard>
  );
}
